module.exports = __webpack_public_path__ + "img/course-13.9fcebb38.png";